import ACTIONS, { FETCH_STATUS } from "../constants";


//----------------------------------- CHANGE REQUEST -----------------------------------

// SORT CHANGE REQUESTS

export const sortChangeRequestRequest = (state) => ({
  type: ACTIONS.SORT_CHANGE_REQUEST_CALL,
  payload: state,
});

export const sortChangeRequestRequestAttempt = {
  pending: {
    type: ACTIONS.SORT_CHANGE_REQUEST.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.SORT_CHANGE_REQUEST.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.SORT_CHANGE_REQUEST.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

// GET CHANGE REQUESTS

export const getChangeRequests = (state) => ({
  type: ACTIONS.CHANGE_REQUEST_CALL,
  payload: state,
});

export const getChangeRequestsAttempt = {
  pending: {
    type: ACTIONS.CHANGE_REQUEST.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.CHANGE_REQUEST.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.CHANGE_REQUEST.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

// CREATE CHANGE REQUEST

export const createChangeRequest = (state) => ({
  type: ACTIONS.CREATE_CHANGE_REQUEST_CALL,
  payload: state,
});

export const createChangeRequestAttempt = {
  pending: {
    type: ACTIONS.CREATE_CHANGE_REQUEST.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.CREATE_CHANGE_REQUEST.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.CREATE_CHANGE_REQUEST.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

// UPDATE CHANGE REQUEST

export const updateChangeRequest = (state) => ({
  type: ACTIONS.UPDATE_CHANGE_REQUEST_CALL,
  payload: state,
});

export const updateChangeRequestAttempt = {
  pending: {
    type: ACTIONS.UPDATE_CHANGE_REQUEST.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.UPDATE_CHANGE_REQUEST.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.UPDATE_CHANGE_REQUEST.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

// DELETE CHANGE REQUEST

export const deleteChangeRequest = (state) => ({
  type: ACTIONS.DELETE_CHANGE_REQUEST_CALL,
  payload: state,
});

export const deleteChangeRequestAttempt = {
  pending: {
    type: ACTIONS.DELETE_CHANGE_REQUEST.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.DELETE_CHANGE_REQUEST.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.DELETE_CHANGE_REQUEST.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const createRiskRequest = (state) => ({
  type: ACTIONS.CREATE_CHANGE_REQUEST_RISK_CALL,
  payload: state,
});

export const createRiskRequestAttempt = {
  pending: {
    type: ACTIONS.CREATE_CHANGE_REQUEST_RISK.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.CREATE_CHANGE_REQUEST_RISK.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.CREATE_CHANGE_REQUEST_RISK.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const updateChangeRequestFlag = (state) => ({
  type: ACTIONS.CHANGE_REQUEST_FLAG_CALL,
  payload: state,
});

export const updateChangeRequestFlagAttempt = {
  pending: {
    type: ACTIONS.CHANGE_REQUEST_FLAG.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.CHANGE_REQUEST_FLAG.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.CHANGE_REQUEST_FLAG.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

